import { useEffect, useState } from "react";
import "./styles/SearchBar.css";
import { Button, IconButton } from "@mui/material";
import { Close, Search } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import { useSearchParams } from "react-router-dom";
const SearchBar = ({ getExams, setExams, exams, allExams }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [userInput, setUserInput] = useState(searchParams.get("search") || "");

  function searchExams(event) {
    event.preventDefault();
    let result = exams?.filter((exam) => {
      if (exam.name.toLowerCase().includes(userInput.toLowerCase())) {
        return true;
      } else if (
        exam.description.toLowerCase().includes(userInput.toLowerCase())
      ) {
        return true;
      }
      return false;
    });
    setExams(result);
  }

  useEffect(() => {
    if (userInput === "") {
      setSearchParams({});
    } else {
      setSearchParams({ search: userInput });
    }
  }, [userInput, setSearchParams]); // Removed allExams from dependency

  return (
    <div className="search-bar" id="exams-search">
      {" "}
      <form onSubmit={(e) => searchExams(e)} style={{ width: "inherit" }}>
        <div className="search">
          <input
            value={userInput}
            name="search-bar"
            onChange={(e) => setUserInput(e.target.value)}
            placeholder="Search..."
            type="text"
            autoComplete="off"
            list="autocompleteOff"
            onKeyDownCapture={(e) => {
              if (e.key === "Enter") {
                searchExams(e);
              }
            }}
          />
          <div className="d-flex justify-center">
            {userInput !== "" ? (
              <IconButton
                onClick={() => {
                  setUserInput("");
                  setExams(allExams);
                }}
                sx={{
                  borderRadius: 0,
                }}
              >
                <Close fontSize="small" />
              </IconButton>
            ) : (
              <div className="spacer"></div>
            )}
            <IconButton
              type="submit"
              disabled={allExams?.length === 0}
              sx={{
                borderRadius: 0,
              }}
            >
              <Search fontSize="small" />
            </IconButton>
          </div>
        </div>
      </form>
      <div className="desktop">
        <Button
          href="/exams/new"
          variant="contained"
          disableElevation
          className="px-4 button-link"
          sx={{ height: "3rem", minWidth: "max-content" }}
          color="primary"
          startIcon={<AddIcon color="white" />}
        >
          New Exam
        </Button>
      </div>
    </div>
  );
};

export default SearchBar;
